<style>
  #sso_state{
    display: none;
  }
</style>

<template>
  <div id="sso_state"></div>
</template>

<script>
import { mapActions } from 'vuex'
import { USER_SIGNIN, USER_SIGNOUT } from '../../stores/user'

export default {
  name: 'sso',
  mounted () {
    window.CheckSSOLogin = this.logined
    window.SSONotInfo = this.nologin
    this.check(process.env.SSO_URI + 'default.aspx?action=checkssologin')
  },
  methods: {
    ...mapActions([USER_SIGNIN, USER_SIGNOUT]),
    nologin () {
      this.USER_SIGNOUT()
    },
    logined (uid) {
      this.$http.get(`${process.env.API_URI}api/user/info`, {
        params: {
          uid: uid
        }
      }).then(res => {
        Object.assign(res.body, {uid: uid})
        this.USER_SIGNIN(res.body)
      }, e => console.log(e))
    },
    check (uri) {
      uri = uri + '&t=' + new Date().getTime()
      let script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = uri
      script.id = 'domain_sso'
      document.body.appendChild(script)
    }
  }
}
</script>



// WEBPACK FOOTER //
// sso.vue?28be5682